import { render } from "./CustomerInfosModal.vue?vue&type=template&id=3a508da1&scoped=true&ts=true&lang=pug"
import script from "./CustomerInfosModal.vue?vue&type=script&lang=ts"
export * from "./CustomerInfosModal.vue?vue&type=script&lang=ts"

import "./CustomerInfosModal.vue?vue&type=style&index=0&id=3a508da1&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a508da1"]])

export default __exports__